/**
 * Step 4: Diagnóstico Jurídico e Tributário
 */
import type { StepProps } from "./types.js";
import { Checkbox } from "./FormElements.jsx";

interface Dependente {
  nome: string;
  parentesco: string;
  dataNasc: string;
}

export function Step4Juridico({ form, onChange, T }: StepProps) {
  const set = (key: string, value: unknown) => onChange(key, value);
  const dependentes = (form.dependentes as Dependente[] | undefined) || [];

  const setDependente = (i: number, field: string, value: string) => {
    const dep = [...dependentes];
    dep[i] = { ...dep[i], [field]: value };
    set("dependentes", dep);
  };

  const addDependente = () => {
    set("dependentes", [...dependentes, { nome: "", parentesco: "", dataNasc: "" }]);
  };

  const removeDependente = (i: number) => {
    set(
      "dependentes",
      dependentes.filter((_, j) => j !== i)
    );
  };

  return (
    <>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.text, margin: "0 0 6px" }}>
        5. Diagnóstico Jurídico e Tributário
      </h3>
      <p style={{ fontSize: 12, color: T.sub, margin: "0 0 16px" }}>
        Informações para o braço Pimentel de Oliveira Advogados.
      </p>
      <div style={{ marginBottom: 20 }}>
        <Checkbox
          label="Possui Holding Patrimonial constituída?"
          checked={form.holdingConst as boolean | undefined}
          onChange={(e) => set("holdingConst", e.target.checked)}
          T={T}
        />
        <Checkbox
          label="Possui testamento ou planejamento sucessório formal?"
          checked={form.testamento as boolean | undefined}
          onChange={(e) => set("testamento", e.target.checked)}
          T={T}
        />
        <Checkbox
          label="Realiza declaração de Capitais Brasileiros no Exterior – CBE?"
          checked={form.declaraCBE as boolean | undefined}
          onChange={(e) => set("declaraCBE", e.target.checked)}
          T={T}
        />
      </div>
      <div>
        <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 10 }}>
          Dependentes / Herdeiros
        </div>
        {dependentes.map((d, i) => (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 130px 32px",
              gap: 8,
              marginBottom: 8,
              alignItems: "center",
            }}
          >
            <input
              placeholder="Nome Completo"
              value={d.nome || ""}
              onChange={(e) => setDependente(i, "nome", e.target.value)}
              style={{
                padding: "7px 10px",
                borderRadius: 7,
                border: `1px solid ${T.border}`,
                background: T.bg,
                color: T.text,
                fontSize: 12,
              }}
            />
            <input
              placeholder="Grau de Parentesco"
              value={d.parentesco || ""}
              onChange={(e) => setDependente(i, "parentesco", e.target.value)}
              style={{
                padding: "7px 10px",
                borderRadius: 7,
                border: `1px solid ${T.border}`,
                background: T.bg,
                color: T.text,
                fontSize: 12,
              }}
            />
            <input
              type="date"
              value={d.dataNasc || ""}
              onChange={(e) => setDependente(i, "dataNasc", e.target.value)}
              style={{
                padding: "7px 10px",
                borderRadius: 7,
                border: `1px solid ${T.border}`,
                background: T.bg,
                color: T.text,
                fontSize: 12,
              }}
            />
            <button
              onClick={() => removeDependente(i)}
              style={{
                padding: "6px",
                borderRadius: 6,
                background: T.dangerBg,
                border: "none",
                color: T.danger,
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              ✕
            </button>
          </div>
        ))}
        <button
          onClick={addDependente}
          style={{
            padding: "7px 14px",
            borderRadius: 7,
            border: `1px dashed ${T.border}`,
            background: "transparent",
            color: T.sub,
            cursor: "pointer",
            fontSize: 12,
            marginTop: 4,
          }}
        >
          + Adicionar Dependente
        </button>
      </div>
    </>
  );
}
